import React 				from 'react';
import ReactDOM 			from 'react-dom';
import BLComponent			from '../../core/_BLComponent.jsx';

import CustomCheckbox 		from '../../common/_CustomCheckbox.jsx';
import { ItemTypeNameUtil } from '../controller/MyCollectionUtils.js';

export default class PartOutModalBody extends BLComponent 
{
	
	constructor ( props, context )
	{
		super( props, context );	// This should come first. 
		
	}

	render()
	{
		const {statusPartOut} = this.props.data;
		
		return (
			<section className="personal-inventory__part-out-modal-body l-pad--bottom">
				{(statusPartOut == 1)&&this.renderPartOutModalBody()}
				{((statusPartOut == 2) || (statusPartOut == 4))&&this.renderPartOutSpinning()}
				{(statusPartOut == 3)&&this.renderPartOutFirstAttemptError()}
				{(statusPartOut == 5)&&this.renderPartOutFinalError()}
				{(statusPartOut == 99)&&this.renderPartOutSucceed()}
			</section>
		);
	}

	renderPartOutModalBody()
	{
		const {itemType} = this.props.data;
		const modalWithOptions = ( (itemType != "M") )?true:false;
		
		return (
			<React.Fragment>
				{(modalWithOptions)?this.renderPartOutWithOptions():this.renderPartOutWithOutOptions()}
			</React.Fragment>
		)
	}

	renderPartOutWithOutOptions() 
	{
		const {itemName, itemType} = this.props.data;
		const itemTypeName = ItemTypeNameUtil.getFullName(itemType).toLowerCase();
		return (
			<React.Fragment>
				<div>
					Do you want to part out <strong>{itemName}</strong>? This will add all parts from this item to your My Parts collection.
				</div>
				
				<div className="personal-inventory__info-box personal-inventory__info-box--yellow l-margin-top l-flex">
					<div>
						<i className="fas fa-exclamation-circle l-margin-right"/>
					</div>
					<div>
						There is currently no way to bulk delete from your My Parts collection. We recommend only parting out {itemTypeName} that you own.
					</div>
				</div>
			</React.Fragment>
		)
	}

	renderPartOutWithOptions() 
	{
		const {itemName, itemType, itemInvData} = this.props.data;
		const partoutOptions = this.props.partoutOptions;
		const itemTypeName = ItemTypeNameUtil.getFullName(itemType).toLowerCase();
		
		return (
			<React.Fragment>
				<div>
					Please choose your options for parting out <strong>{itemName}</strong>. This will add the following to your My Parts:
				</div>
				<div>
					<div className="l-flex l-margin-top">
						<div>
							<CustomCheckbox isDark isDisabled={(itemInvData.nRegInvCnt == 0)} isChecked={partoutOptions.incRegularParts} onChangeFunc={() => this.props.updatePartout("r") } />
						</div>
						<div className="l-margin-left--sm">Include Regular Parts</div>
					</div>
					<div className="l-flex l-margin-top">
						<div>
							<CustomCheckbox isDark isDisabled={(itemInvData.nExtraInvCnt == 0)} isChecked={partoutOptions.incExtraParts} onChangeFunc={() => this.props.updatePartout("e") } />
						</div>
						<div className="l-margin-left--sm">Include Extra Parts</div>
					</div>
					<div className="l-flex l-margin-top">	
						<div>
							<CustomCheckbox isDark isDisabled={ ( (itemInvData.nMinifigureCnt == 0) || !partoutOptions.incRegularParts) } isChecked={partoutOptions.breakMinifig} onChangeFunc={() => this.props.updatePartout("m")} />
						</div>
						<div className="l-margin-left--sm">
							<div>Break Minifigures</div>
							<div>(If this box is unchecked, whole Minifigure(s) will be added to your My Minifigures collection)</div>
						</div>
						
					</div>
				</div>
				<div className="personal-inventory__info-box personal-inventory__info-box--yellow l-margin-top l-flex">
					<div>
						<i className="fas fa-exclamation-circle l-margin-right"/>
					</div>
					<div>
						There is currently no way to bulk delete from your My Parts collection. We recommend only parting out {itemTypeName} that you own.
					</div>
				</div>
			</React.Fragment>
		)
	}

	renderPartOutSpinning()
	{
		return (
			<React.Fragment>
				<button className="text--title"><i className="fas fa-spinner fa-pulse"/></button>
				<div className="text--center l-margin-top--sm">Parting out</div>
			</React.Fragment>
		)
	}

	renderPartOutSucceed() 
	{
		const {itemType} = this.props.data;
		const itemTypeList = {P:"Part", B:"Book", M:"Minifigure", C:"Catalog", S:"Set", G:"Gear"};
		const itemTypeName = itemTypeList[itemType].toLowerCase();
		return (
			<React.Fragment>
				<div className="l-flex l-center-v text--bold">My Parts has been updated</div>
				<div className="l-margin-top--xl text--center">
					<i className="modal-icon--succeed fas fa-check-circle"></i>
				</div>
				<div className="l-margin-top--xl l-margin-bottom">
					Success! You’ve made the following changes to My Parts:
					<div className="l-margin-top">
						<li className="text--bold">1 {itemTypeName} inventories added to My Parts</li>
					</div>
				</div>
			</React.Fragment>
		)

		
	}
	renderPartOutFirstAttemptError()
	{
		return (
			<React.Fragment>
				<div className="l-flex l-center-v text--bold">Error updating My Parts</div>
				<div className="l-margin-top--xl text--center">
					<i className="modal-icon--exclamation fas fa-exclamation-triangle"></i>
				</div>
				<div className="l-margin-top--xl l-margin-bottom text--center">
					Ooops! There was an error updating your personal inventory. Please try again.
				</div>
			</React.Fragment>
		)
	}
	renderPartOutFinalError()
	{
		return (
			<React.Fragment>
				<div className="l-flex l-center-v text--bold">Error updating My Parts</div>
				<div className="l-margin-top--xl text--center">
					<i className="modal-icon--exclamation fas fa-exclamation-triangle"></i>
				</div>
				<div className="l-margin-top--xl l-margin-bottom text--center">
					Sorry, it seems like we're having some problems on our end. Please try again later.
				</div>
			</React.Fragment>
		)
	}
};

 

